import { Outlet } from 'react-router-dom';

export const ControllerOutlet = () => <Outlet />;
